import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import "./Avatar.css";

import AvatarImage from "../../assets/profile.png";

interface AvatarProps {
  mouthRef: React.RefObject<HTMLDivElement | null>;
  isThinking: boolean;
}

const Avatar: React.FC<AvatarProps> = ({ mouthRef, isThinking }) => {
  const [blinking, setBlinking] = useState(false);
  const { t } = useTranslation();

  // 눈 깜빡임 로직
  useEffect(() => {
    const blinkInterval = setInterval(() => {
      setBlinking(true);
      setTimeout(() => setBlinking(false), 100);
    }, 3000);

    return () => clearInterval(blinkInterval);
  }, []);

  return (
    <div className="character-wrapper">
      {/* 생각 중 말풍선 */}
      {isThinking && (
        <div className="thinking-bubble thought-cloud">
          <div className="thinking-content">
            <span className="thinking-emoji"></span>
            <span className="thinking-text">{t("thinking")}</span>
          </div>
          <div className="particles">
            <div className="sparkle"></div>
            <div className="sparkle"></div>
            <div className="sparkle"></div>
          </div>
        </div>
      )}

      <div
        className="character-container"
        style={{
          backgroundImage: `url(${AvatarImage})`,
        }}
      >
        <div className="movable-parts">
          {/* 눈 영역 */}
          <div className="eye-container">
            <div className={`eye left ${blinking ? "blinking" : ""}`}></div>
            <div className={`eye right ${blinking ? "blinking" : ""}`}></div>
          </div>

          {/* 입 영역 */}
          <div className="mouth-container">
            {/* useAudio 훅이 이 div의 classList를 직접 조작함 */}
            <div ref={mouthRef} className="mouth"></div>
            {/* 입 윗부분을 가려주는 커버 (피부색) */}
            <div className="mouth-cover"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Avatar;
